import { PlayerScoringOption } from './PlayerScoringOption';
import type { PlayerScoringQuestionProps } from '@/utils/scoring/adapters/playerScoringAdapter';
import type { MatchStatsResponse } from '@/api/feed/getFeedMatchStats';

interface PlayerScoringQuestionComponentProps extends PlayerScoringQuestionProps {
  questionId?: string;
  fixtureId?: string;
  onMarkCorrect?: (optionId: string, isCorrect: boolean) => void;
  onSave?: (optionId: string) => void;
  onCancel?: (optionId: string) => void;
  language?: 'en' | 'fr';
  manualScoring?: boolean;
  matchStats?: MatchStatsResponse;
  onStatChange?: (optionId: string, statValue: number) => void;
  onOverrideSuccess?: () => void;
}

export function PlayerScoringQuestion({
  questionId,
  fixtureId,
  options,
  statTypeCode,
  points,
  onSave,
  onCancel,
  language = 'en',
  manualScoring = false,
  matchStats,
  onStatChange,
  onOverrideSuccess,
}: PlayerScoringQuestionComponentProps) {
  return (
    <div className="space-y-3">
      {/* Options - Side by side when ≤4, single column list when >4 */}
      <div className={`flex gap-4 ${options.length > 4 ? 'flex-col' : 'flex-row flex-wrap'}`}>
        {options.map((option, index) => (
          <PlayerScoringOption
            key={option.option_id || index}
            questionId={questionId}
            fixtureId={fixtureId}
            option={option}
            statTypeCode={statTypeCode}
            questionPoints={points}
            language={language}
            manualScoring={manualScoring}
            matchStats={matchStats}
            onStatChange={onStatChange}
            onSave={onSave}
            onCancel={onCancel}
            onOverrideSuccess={onOverrideSuccess}
            listLayout={options.length > 4}
          />
        ))}
      </div>
    </div>
  );
}
